<script>
import Loading from './spinner.vue'

export default {
  name: 'load',
  components: {
    Loading
  },
  props: {
    mask: {
      type: Boolean,
      default: false
    },
    message: {
      type: String,
      default: '网络错误'
    }
  },
  data () {
    return {
      // loading/success/fail
      status: 'success'
    }
  },
  methods: {
    reload () {
      location.reload()
    },
    loading () {
      this.status = 'loading'
    },
    hide () {
      this.status = 'success'
    },
    error () {
      this.status = 'error'
    }
  }
}
</script>

<template>
  <div class="load_container" :class="mask && 'load_mask'" v-show="status !== 'success'">
    <Loading v-show="status === 'loading'"/>
    <div v-show="status === 'error'" class="load_error">
      {{message}}
      <span class="load_reload" @click="reload"> 点击重试</span>
    </div>
  </div>
</template>

<style lang="stylus">
.load_container
  position fixed
  top 0
  bottom 0
  left 0
  right 0
  display flex
  align-items center
  justify-content center
  font-size 16px
.load_reload
  color $primary-color
</style>
